import { Component, Input } from '@angular/core';
import { DateService } from '@nida-web/core';
import type { Patient, PatientView } from '@nida-web/api/generic-interfaces/patient-management';
import { TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'nida-web-patient-personal-data',
  templateUrl: './patient-personal-data.component.html',
  styleUrls: ['./patient-personal-data.component.scss'],
  standalone: false,
})
export class PatientPersonalDataComponent {
  @Input() patientData: PatientView;
  @Input() detailData: Patient;

  @Input() loaded: boolean;

  constructor(protected dateService: DateService, private translocoService: TranslocoService) {}

  formatMoment(value: string | null | undefined, type: string) {
    if (value) {
      return this.dateService.formatMoment(value, type);
    }
    return null;
  }

  concatAddress(): string {
    // join all elements to one string, but only join them when they are filled, so displayNan Pipe can do its job
    return [this.detailData.street, this.detailData.houseNumber, this.detailData.postcode, this.detailData.city].filter(Boolean).join(' ');
  }

  formatAgeInformation(): string {
    let ageString = '';
    if (this.patientData.age && this.patientData.ageType) {
      ageString = [this.patientData.age, this.translocoService.translate(this.patientData.ageType)].join(' ');
    }
    return ageString;
  }
}
